import axios from "axios";
let isMobile = function () {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
}
let getBanner = function (articleType, userType) {
   return axios.get(`/public/appArticle/site/page?articleType=${articleType}&userType=${userType}`)
}

export default {
    isMobile,
    getBanner
}